import ContentBox from 'components/ContentBox'
import {
  STYLES_FONT_SIZE,
  STYLES_WORD_BREAK
} from 'modules/styles/constants/index.cjs'
import PropTypes from 'prop-types'
import React from 'react'
import { usePreviousHookUtil } from 'modules/component/utils/hooks/usePrevious.js'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen/index.js'
import isDifferentLocationWithoutQueryLocationUtil from 'modules/router/utils/is-different-location-without-query/index.js'
import { ArticleContentChunks } from 'pages/Article/Content/components/Chunks/index.js'
import { ArticleProgressBar } from 'pages/Article/ProgressBar/index.js'

/**
 * @param props
 * @param props.value
 * @param props.title
 * @param props.url
 * @param props.location
 * @param props.children
 * @param props.hasShareButtons
 * @param props.img
 * @return {React.JSX.Element}
 * @constructor
 */
export function ArticleContent (props) {
  const {
    value,
    title,
    url,
    location,
    children,
    hasShareButtons,
    img
  } = props

  const prevLocation = usePreviousHookUtil(location)
  const hasRenderedShareAfterImageRef = React.useRef()
  const hasRenderedNewsletterRef = React.useRef()
  const articleRef = React.useRef()
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  const prevIsSmallScreen = usePreviousHookUtil(isSmallScreen)

  const resetRefs = () => {
    hasRenderedShareAfterImageRef.current = false
    hasRenderedNewsletterRef.current = false
  }

  React.useEffect(() => {
    if (
      prevIsSmallScreen &&
      prevIsSmallScreen !== isSmallScreen
    ) {
      resetRefs()
    }
  }, [
    prevIsSmallScreen,
    isSmallScreen
  ])

  React.useEffect(() => {
    const isDifferentLocation = (
      isDifferentLocationWithoutQueryLocationUtil(
        prevLocation,
        location
      )
    )

    if (!isDifferentLocation) {
      return
    }

    resetRefs()
  }, [
    location,
    prevLocation
  ])

  return (
    <ContentBox>
      <ArticleProgressBar articleRef={articleRef} />
      <article
        ref={articleRef}
        className='article-content'
        style={{
          wordBreak: STYLES_WORD_BREAK.BREAK_WORD,
          width: '100%',
          fontSize: STYLES_FONT_SIZE.BODY_BIG
        }}
      >
        <ArticleContentChunks
          value={value}
          title={title}
          url={url}
          hasShareButtons={hasShareButtons}
          hasRenderedShareAfterImageRef={hasRenderedShareAfterImageRef}
          img={img}
        />
      </article>
      {children}
    </ContentBox>
  )
}

ArticleContent.propTypes = {
  value: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired,
  hasCommentHash: PropTypes.bool,
  hasShareButtons: PropTypes.bool,
  img: PropTypes.string.isRequired
}
